import { ArrowLeft, HeaderStyles, X, cn } from 'scbk-ui-web';

import { useTranslation } from 'react-i18next';
import { useAppContext } from 'scbk-services';
import { DataAttributes } from '../types/HeaderType';

interface SubHeaderProps {
  title?: string | React.ReactNode | undefined;
  onClose?: () => void;
  onHistoryClick?: () => void;
  onAlertPanel?: () => void;
  onSearchPanel?: () => void;
  isScrolled?: boolean;
  isBackBtn?: boolean;
  className?: string;
  titleProps?: DataAttributes;
  closeProps?: DataAttributes;
  darkMode?: boolean;
  openUserInfoPopup?: () => void;
}

const WhiteHeader = ({
  title,
  onHistoryClick,
  isScrolled = false,
  isBackBtn = true,
  onClose,
  titleProps,
  closeProps,
  openUserInfoPopup,
}: SubHeaderProps) => {
  // 다국어처리
  const { t } = useTranslation();

  const { darkMode, seniorMode } = useAppContext();

  return (
    <div
      className={cn(
        HeaderStyles['sub-header-fixed'],
        'bg-base-white',
        isScrolled ? HeaderStyles.scrolled : '',
      )}
    >
      <header className={HeaderStyles['sub-header-wrap']}>
        <div className={HeaderStyles['sub-header-flex']}>
          {isBackBtn && (
            <button
              id="btnHeaderBack"
              aria-label={t('Layout.WhiteHeader.001', {
                defaultValue: '돌아가기',
              })}
              onClick={onHistoryClick}
              className="back-btn"
            >
              {darkMode === 'Y' && seniorMode === 'Y' ? (
                <ArrowLeft fill="#fff" width={24} height={24} />
              ) : (
                <ArrowLeft fill="#000" width={24} height={24} />
              )}
            </button>
          )}
          <h1
            className={HeaderStyles.title}
            {...titleProps}
            onClick={(e) => {
              e.preventDefault();
              openUserInfoPopup?.();
            }}
          >
            {title}
          </h1>
          <button
            id="btnHeaderClose"
            aria-label={t('Layout.WhiteHeader.002', {
              defaultValue: '닫기',
            })}
            {...closeProps}
            onClick={onClose}
            className="close-btn"
          >
            {darkMode === 'Y' && seniorMode === 'Y' ? <X fill="#fff" /> : <X fill="#000" />}
          </button>
        </div>
      </header>
    </div>
  );
};

export { WhiteHeader };
